import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import cl from "../styles/ProfilePage.module.css";
import defaultBanner from "../Assets/banner-photo.svg";
import pencil from "../Assets/icons/pencil.svg";
import NotificationCard from "../components/UI/ProfileNotification/NotificationCard";
import SettingsMain from "../components/UI/ProfileSettings/SettingsMain";
import ChangePassword from "../components/UI/ProfileSettings/SettingsChangePassword";
import EditProfile from "../components/UI/ProfileEdit/ProfileEdit";
import Banner from "../components/UI/ProfileBanner/ProfileBanner";
import noNotificationsImg from "../Assets/icons/no_notifications.svg";
import back from "../Assets/icons/backToDash.svg";
import check from "../Assets/icons/check_circle_outline_forText.svg";
import avatarDefault from "../Assets/default_avatar.svg";
import Service from "../API/Service";



const ProfilePage = () => {
    const navigate = useNavigate();
    const location = useLocation(); 
    const [activeTab, setActiveTab] = useState("profile");
    const [activeToggle, setActiveToggle] = useState(false);
    const [isChangePassword, setIsChangePassword] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [savedBanner, setSavedBanner] = useState(defaultBanner);
    const [profileData, setProfileData] = useState(null);
    const [notifications, setNotifications] = useState([]);
    const [successMessage, setSuccessMessage] = useState("");

    useEffect(() => {
        if (location.state?.successMessage) {
            setSuccessMessage(location.state.successMessage);
            setTimeout(() => setSuccessMessage(""), 2000); 
        }
    }, [location.state]);

    useEffect(() => {
        if (location.state?.activeTab) {
            setActiveTab(location.state.activeTab);
        }
    }, [location.state]);

    const handleMarkAsRead = async (notificationId) => {
        try {
            const response = await Service.markNotificationAsRead(notificationId);
            if (response.status === 200) {
                setNotifications(prevNotifications =>
                    prevNotifications.map(notification =>
                        notification.id === notificationId
                            ? { ...notification, isRead: true }
                            : notification
                    )
                );
            }
        } catch (error) {
            console.error("Error marking notification as read:", error);
        }
    };


    const handleMarkAllAsRead = async () => {
        try {
            const response = await Service.markAllNotificationsAsRead();
            if (response.status === 200) {
                setNotifications(prevNotifications =>
                    prevNotifications.map(notification => ({
                        ...notification,
                        isRead: true
                    }))
                );
            }
        } catch (error) {
            console.error("Error marking all notifications as read:", error);
        }
    };

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const data = await Service.getPersonalData();
                
                setProfileData({
                    login: data.login || "Email",
                    name: data.name || "Unknown",
                    surname: data.surname || "User",
                    phone: data.phone || "Not specified",
                    birthDate: formatDate(data.birthDate) || "Unknown", 
                    photoMetadataLink: data.photoMetadataLink || avatarDefault,
                    banner: data.banner || defaultBanner,
                });
            } catch (error) {
                console.error("Error fetching profile data:", error);
            }
        };
        fetchProfile();
    }, []);

    const formatDate = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleDateString("en-GB"); // Format: DD/MM/YYYY
    };
    
    const formatTime = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }); // Format: HH:MM
    };


    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                const data = await Service.getUnreadNotifications();
                const formattedNotifications = data.map(notification => ({
                    id: notification.id,
                    title: notification.header,
                    message: notification.text,
                    time: formatTime(notification.sent),
                    date: formatDate(notification.sent),
                    isRead: false
                }));
                setNotifications(formattedNotifications);
                console.log("Updated notifications state:", formattedNotifications);
            } catch (error) {
                console.error("Error fetching notifications:", error);
            }
        };
    
        fetchNotifications();
    }, []);



    if (!profileData) {
        return <p>Loading...</p>;
    }



    const handleToggle = () => {
        setActiveToggle(!activeToggle);
    };

    const handleSave = (newBanner) => {
        setSavedBanner(newBanner);
        setIsEditing(false);
      };


    return (
        <div>

        {successMessage && (
            <div className={cl.successMessage}>
                {successMessage}
            </div>
        )}
        
        <div className={cl.profileContainer}>
            <button className={cl.backButton} onClick={() => navigate("/main")}>
                    <img src={back} alt="Back" />
                    Back to Dashboard
                </button>
<div>
      <Banner isEditing={isEditing} savedBanner={savedBanner} onSave={handleSave} />
     
    </div>

            {isEditing ? (
                <EditProfile profileData={profileData} setProfileData={setProfileData} setIsEditing={setIsEditing} />
            ) : (
                <div className={cl.profile}>
                    <div className={cl.upperPart}>
                        <div className={cl.info}>
                            <div className={cl.avatar}>
                                <img src={profileData.photoMetadataLink} alt="avatar" />
                            </div>
                            <div className={cl.name}>
                                <div className={cl.userName}>{profileData.name} {profileData.surname}</div>
                                <div className={cl.userRole}>Admin</div>
                            </div>
                        </div>
                        <button className={cl.editBtn} onClick={() => setIsEditing(true)}>
                            Edit
                            <img src={pencil} alt={'pencil'} />
                        </button>
                    </div>
                    <div className={cl.bottomPart}>
                        <div className={cl.navigation}>
                            <div className={cl.headers}>
                                <button
                                    className={`${cl.headerButton} ${activeTab === "profile" ? cl.activeButton : ""}`}
                                    onClick={() => setActiveTab("profile")}
                                >
                                    My Profile
                                </button>
                                <button
                                    className={`${cl.headerButton} ${activeTab === "notifications" ? cl.activeButton : ""}`}
                                    onClick={() => setActiveTab("notifications")}
                                >
                                    Notification
                                </button>
                                <button
                                    className={`${cl.headerButton} ${activeTab === "settings" ? cl.activeButton : ""}`}
                                    onClick={() => setActiveTab("settings")}
                                >
                                    Settings
                                </button>
                            </div>
                            <div className={cl.headerUnderline}></div>
                        </div>
                        <div>
                            {activeTab === "profile" && (
                                <dl className={cl.userInfo}>
                                    <div className={cl.userInfoRow}>
                                        <dt>Name</dt>
                                        <dd>{profileData.name} </dd>
                                    </div>
                                    <div className={cl.userInfoRow}>
                                        <dt>Surname</dt>
                                        <dd>{profileData.surname}</dd>
                                    </div>
                                    
                                    <div className={cl.userInfoRow}>
                                        <dt>Date of birth</dt>
                                        <dd>{profileData.birthDate}</dd>
                                    </div>
                                    <div className={cl.userInfoRow}>
                                        <dt>Email</dt>
                                        <dd>{profileData.login}</dd>
                                    </div>
                                    
                                    <div className={cl.userInfoRow}>
                                        <dt>Phone number</dt>
                                        <dd>{profileData.phone}</dd>
                                    </div>
                                </dl>
                            )}
                            {activeTab === "notifications" && (
                                <div className={cl.notList}>
                                    
                                    {notifications.length > 0 && (
                                        <button onClick={handleMarkAllAsRead} className={cl.readAllButton}>
                                            Read all notifications
                                            <img src={check} alt="check icon" className={cl.checkIcon} />
                                        </button>
                                    )}
                                    {notifications.length > 0 ? (

                                        
                                        notifications.map((notification) => (
                                            <NotificationCard
                                                key={notification.id}
                                                title={notification.title}
                                                message={notification.message}
                                                time={notification.time}
                                                date={notification.date}
                                                isRead={notification.isRead}
                                                handleReadStatus={() => handleMarkAsRead(notification.id)} 
                                            />
                                        ))
                                    ) : (
                                        <div className={cl.noNotifications}>
                                            <img src={noNotificationsImg} alt="No Notifications" />
                                            <p>You have no notifications</p>
                                        </div>
                                    )}
                                </div>
                            )}
                            {activeTab === "settings" &&
                                (isChangePassword ? (
                                    <ChangePassword setIsChangePassword={setIsChangePassword} />
                                ) : (
                                    <SettingsMain activeToggle={activeToggle} handleToggle={handleToggle} setIsChangePassword={setIsChangePassword} />
                                ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
        </div>
    );
    
};

export default ProfilePage;
